import { render } from "./NewUploadSIMSubscribersPage.vue?vue&type=template&id=610b03d0"
import script from "./NewUploadSIMSubscribersPage.vue?vue&type=script&lang=js"
export * from "./NewUploadSIMSubscribersPage.vue?vue&type=script&lang=js"

import "./NewUploadSIMSubscribersPage.vue?vue&type=style&index=0&id=610b03d0&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__